import { ReactComponent as CalendarIcon } from "../../assets/img/events/calendar.svg";
import { ReactComponent as DateRangeIcon } from "../../assets/img/events/date.svg";
import { ReactComponent as LocationIcon } from "../../assets/img/events/location.svg";
import { ReactComponent as PriceIcon } from "../../assets/img/events/price.svg";
import { ReactComponent as TimeIcon } from "../../assets/img/events/time.svg";
import { useUserTimezone } from "hooks/useUserTimezone";
import { CalendarFriendlyEvent, dateRangeToDisplay, formatDate, timeToDisplay } from "./types";

type UpcomingEventsProps = {
    futureEventsFormatted: CalendarFriendlyEvent[];
    onSelectEvent: (event: CalendarFriendlyEvent) => void;
    onOpenModal: (event: CalendarFriendlyEvent) => void;
    onOpenEventDetails: (event: CalendarFriendlyEvent) => void;
};

export const UpcomingEvents = ({
    futureEventsFormatted,
    onOpenEventDetails,
    onOpenModal,
}: UpcomingEventsProps) => {
    const timeZone = useUserTimezone();
    return (
        <div className="space-y-4">
            {futureEventsFormatted.length === 0 ? (
                <div className="shadow-soft rounded-xl border border-gray-200 bg-white p-8 text-center">
                    <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
                        <CalendarIcon />
                    </div>
                    <h3 className="mb-2 text-lg font-semibold text-gray-900">No events found</h3>
                    {/*<p className="text-gray-600">No events match your current filter</p>*/}
                </div>
            ) : (
                futureEventsFormatted.map((item: CalendarFriendlyEvent) => {
                    return (
                        <div
                            key={item.id}
                            className="space-y-1 rounded border-l-[3px] border-l-[#2da7e0] bg-white p-3 shadow-md"
                        >
                            <p
                                className="cursor-pointer font-semibold"
                                onClick={() => onOpenEventDetails(item)}
                            >
                                {item.title}
                            </p>
                            <div className="mb-2 flex flex-col gap-1 text-sm">
                                {item.start && (
                                    <div className="grid grid-cols-[20px_1fr] items-center gap-2">
                                        <DateRangeIcon className="h-5 w-5 flex-shrink-0" />
                                        <div>
                                            {dateRangeToDisplay(item.start, item?.end, timeZone)}
                                        </div>
                                    </div>
                                )}
                                {/*item.end && (
                                        <div className="grid grid-cols-[20px_1fr] items-center gap-2">
                                            <TimeIcon className="h-5 w-5 flex-shrink-0" />
                                            <div>
                                                {item.start
                                                    ? timeToDisplay(new Date(item.start))
                                                    : ""}
                                                {item.start !== item.end && item.end && (
                                                    <> — {timeToDisplay(new Date(item.end))}</>
                                                )}
                                            </div>
                                        </div>
                                    )*/}
                                {item.location && (
                                    <div className="grid grid-cols-[20px_1fr] items-center gap-2">
                                        <LocationIcon className="h-5 w-5 flex-shrink-0" />
                                        <div>{item.location && <span>{item.location}</span>}</div>
                                    </div>
                                )}
                                {item.priceRange && (
                                    <div className="grid grid-cols-[20px_1fr] items-center gap-2">
                                        <PriceIcon className="h-5 w-5 flex-shrink-0" />
                                        <div>
                                            {item.priceRange && <span>{item.priceRange}</span>}
                                        </div>
                                    </div>
                                )}
                            </div>
                            {/* <button
                                    type="button"
                                    onClick={() => onOpenModal(item)}
                                    className="w-full rounded bg-[#3ab0ff] px-4 py-1 text-white hover:bg-[#2196f3]"
                                >
                                    {item.type === "COMPASS" ? "Link here" : "Register"}
                                </button> */}
                        </div>
                    );
                })
            )}
        </div>
    );
};
